import { NgClass } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RouterLink, RouterOutlet } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { Subject, Subscription } from "rxjs";
import { ENVIRONMENT } from "../../../environments/environment";
import { FooterComponent } from "../../components/footer/footer.component";
import { GlobalLoadingComponent } from "../../components/global-loading/global-loading.component";
import { HeaderComponent } from "../../components/header/header.component";
import { MenuComponent, MenuItem } from "../../components/menu/menu";
import { ApplicationService } from "../../services/application.service";
import { AuthService } from "../../services/auth.service";
import { DialogService } from "../../services/dialog.service";

@Component({
  selector: "app-root",
  templateUrl: "./root.html",
  styleUrls: ["./root.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, MenuComponent, GlobalLoadingComponent, HeaderComponent, NgClass, RouterOutlet, FooterComponent, TranslatePipe],
})
export class RootComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly applicationService = inject(ApplicationService);
  readonly dialogService = inject(DialogService);

  @ViewChild("header")
  public headerComponent!: HeaderComponent;

  @ViewChild("warningHTMLDialog") warningHTMLDialog?: TemplateRef<unknown>;

  public initialized = false;

  private auth = inject(AuthService);

  private readonly _destroying$ = new Subject<void>();

  public get menu(): MenuItem[] {
    return this.applicationService.menu;
  }

  private sessionChange$?: Subscription;

  public menuOpen = false;

  public constructor() {
    try {
      const app = this.applicationService;
      app.initialize().catch(() => new Error("A fatal error has caused the application to terminate."));
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * give msg EventMessage value and check if the type is the same as .ACCOUNT_ADDED
   * Or if msg.TypeEvent is the same as ACCOUNT_REMOVED
   * if .getAllAccounts.length is the same as 0 then set window.location to /
   * if there is no interaction status do a todo check and put initialized to true
   */
  public async ngOnInit() {
    this.initialized = true;
    this.sessionChange$ = this.auth.session.subscribe((v) => {
      console.log("init menu??", v);
      this.applicationService.initMenu();
    });

    // this.route.fragment.subscribe((fragment) => {
    //   if (fragment) {
    //     document.querySelector("#" + fragment)?.scrollIntoView();
    //     document.getElementById("content")?.focus();
    //   }
    // });
  }

  public ngAfterViewInit(): void {
    console.log(ENVIRONMENT.WARNING_POPUP, this.warningHTMLDialog);
    if (ENVIRONMENT.WARNING_POPUP && this.warningHTMLDialog) {
      this.dialogService.open({
        template: this.warningHTMLDialog,
        data: {
          text: `WARNING_POPUP.${ENVIRONMENT.WARNING_POPUP}`,
        },
      });
    }
  }

  public skipToContent(elementID: string) {
    (document.getElementById(elementID) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  public checkAndSetActiveAccount() {}

  public ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.sessionChange$?.unsubscribe();
  }

  switchLoading() {
    this.applicationService.setLoading(true);
  }
}
